function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { baseAirlineObject, baseEventObject, baseHospitalityObject } from "./schema.js";
import { version } from './version.js';
import { hangarEnv } from './config.js';
import { tenantList } from "./tenantlist.js";
import { tealiumList } from "./whitelist.js";

/**
 * Returns fully formatted object.
 * @param {object} obj - data layer object.
 * @return {function name(params) { }}} - Returns the formatted object using all format functions
 */

var globalObj = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : this;
globalObj.tp_v = version;
globalObj.tp_debug = false;
var logger = {
  log: function log() {
    if (globalObj && globalObj.tp_debug === true) {
      var _console;
      console.debug('tp_debug is currently active');
      (_console = console).log.apply(_console, arguments);
    } else {
      // do nothing
    }
  }
};
var formatAirlines = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(obj) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          logger.log("Incoming obj: ", JSON.parse(JSON.stringify(obj)));
          obj = ensureFields(obj, baseAirlineObject);
          if (!(obj.module && obj.eventAction)) {
            _context.next = 14;
            break;
          }
          _context.next = 5;
          return addCalculatedParameters(obj);
        case 5:
          convertValues(obj);
          formatDetails(obj, 'airline');
          formatCase(obj);
          formatJourney(obj);
          formatFareClass(obj);
          formatDate(obj, true);
          formatUrl(obj);
          pushFormattedEventData(obj, baseAirlineObject);
          return _context.abrupt("return", obj);
        case 14:
          return _context.abrupt("return", "Module name or eventAction missing.");
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function formatAirlines(_x) {
    return _ref.apply(this, arguments);
  };
}();
var formatHotels = function formatHotels(obj) {
  logger.log("Incoming obj: ", JSON.parse(JSON.stringify(obj)));
  obj = ensureFields(obj, baseHospitalityObject);
  if (obj.module && obj.eventAction) {
    convertValues(obj);
    formatDetails(obj, 'hotel');
    formatCase(obj);
    formatDate(obj);
    formatUrl(obj);
    pushFormattedEventData(obj, baseHospitalityObject);
    return obj;
  }
  return "Module name or eventAction missing.";
};
var formatEvents = function formatEvents(obj) {
  logger.log("Incoming obj: ", JSON.parse(JSON.stringify(obj)));
  obj = ensureFields(obj, baseEventObject);
  if (obj.module && obj.eventAction) {
    convertValues(obj);
    formatJourney(obj);
    formatFareClass(obj);
    formatDetails(obj, 'event');
    formatCase(obj);
    formatDate(obj);
    formatUrl(obj);
    pushFormattedEventData(obj, baseEventObject);
    return obj;
  }
  return "Module name or eventAction missing.";
};
var ensureFields = function ensureFields(obj, baseObj) {
  var _loop = function _loop(key) {
    if (baseObj.hasOwnProperty(key)) {
      if (!obj.hasOwnProperty(key)) {
        obj[key] = Array.isArray(baseObj[key]) ? {} : baseObj[key];
      }
      if (Array.isArray(obj[key]) && _typeof(baseObj[key]) === 'object') {
        obj[key] = obj[key][0] || {};
      }
      if (Array.isArray(baseObj[key]) && Array.isArray(obj[key])) {
        baseObj[key].forEach(function (baseElem, i) {
          obj[key][i] = ensureFields(obj[key][i] || {}, baseElem);
        });
      } else if (_typeof(baseObj[key]) === 'object' && baseObj[key] !== null) {
        obj[key] = ensureFields(obj[key] || {}, baseObj[key]);
      }
    }
  };
  for (var key in baseObj) {
    _loop(key);
  }
  return obj;
};

/**
 * Saves to localStorage
 * @param {object} key - Key of item
 * @param {object} value - Value of item
 */
var saveToLocalStorage = function saveToLocalStorage(key, value) {
  var standardizedVal = _typeof(value) === 'object' || Array.isArray(value) ? JSON.stringify(value) : value;
  localStorage.setItem(key, standardizedVal);
};

/**
  * Returns environment based on url's domain or from EM.dataLayer. Default to PROD if no environment
  * @returns {string} The environment based on url's domain or EM.dataLayer.
  */
var getEnvironment = function getEnvironment() {
  var _window$EM$dataLayer$, _window$EM, _window$EM$dataLayer, _window$EM$dataLayer$2, _window$EM$dataLayer$3, _window, _window$location;
  var environment = (_window$EM$dataLayer$ = (_window$EM = window.EM) === null || _window$EM === void 0 ? void 0 : (_window$EM$dataLayer = _window$EM.dataLayer) === null || _window$EM$dataLayer === void 0 ? void 0 : (_window$EM$dataLayer$2 = _window$EM$dataLayer[0]) === null || _window$EM$dataLayer$2 === void 0 ? void 0 : (_window$EM$dataLayer$3 = _window$EM$dataLayer$2.extraInfo) === null || _window$EM$dataLayer$3 === void 0 ? void 0 : _window$EM$dataLayer$3.environment) !== null && _window$EM$dataLayer$ !== void 0 ? _window$EM$dataLayer$ : (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname;
  var environments = {
    development: ["dev", "prepro", "DEVELOPMENT", "PREPRODUCTION"],
    production: ["production", "PRODUCTION", "prod"]
  };
  for (var _i = 0, _Object$entries = Object.entries(environments); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      keywords = _Object$entries$_i[1];
    if (keywords.some(function (keyword) {
      return environment.includes(keyword) || environment === keyword;
    })) {
      return hangarEnv[key];
    }
  }
  return hangarEnv.production || "";
};

/**
 * Fetches the list of country codes for each airport code from the hangar API
 * @param {string} iataCode - Iata code of airline
 * @return {object} - Returns an object with the list of airport codes and their corresponding country codes
 */
var fetchAirportCountries = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(iataCode) {
    var hangarConfig, url, response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          hangarConfig = getEnvironment();
          if (hangarConfig) {
            _context2.next = 4;
            break;
          }
          console.warn('Hangar configuration is not defined.');
          return _context2.abrupt("return", []);
        case 4:
          _context2.prev = 4;
          url = "".concat(hangarConfig.apiUrl).concat(iataCode.toLowerCase()).concat(hangarConfig.apiPath);
          _context2.next = 8;
          return fetch(url, {
            method: 'POST',
            headers: {
              'EM-API-KEY': hangarConfig.apiKey,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              outputFields: ["countryIsoCode", "iataCode"],
              setting: {
                "airportSource": "TRFX"
              },
              language: "en"
            })
          });
        case 8:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 12;
            break;
          }
          console.error("Error fetching airport countries: ".concat(response.statusText));
          return _context2.abrupt("return", []);
        case 12:
          _context2.next = 14;
          return response.json();
        case 14:
          return _context2.abrupt("return", _context2.sent);
        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](4);
          console.error("Error in fetchAirportCountries: ".concat(_context2.t0.message));
          return _context2.abrupt("return", []);
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 17]]);
  }));
  return function fetchAirportCountries(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Loads the list of country codes for each airport code
 * @param {string} iataCode - Iata code of airline
 * @return {Map} - Returns a map of airport codes and their corresponding country codes
 */
/**
 * @param {string} iataCode
 * @returns {Promise<Array<[string, string]>>}
 */
var loadAirportCountries = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(iataCode) {
    var list, already, airportCountries, newEntries;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(typeof iataCode !== 'string' || !iataCode.trim())) {
            _context3.next = 3;
            break;
          }
          console.warn('loadAirportCountries: invalid iataCode');
          return _context3.abrupt("return", new Map());
        case 3:
          list = JSON.parse(localStorage.getItem('airportCountryCodes') || '[]');
          already = list.some(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 1),
              code = _ref5[0];
            return code === iataCode;
          });
          if (already) {
            _context3.next = 10;
            break;
          }
          _context3.next = 8;
          return fetchAirportCountries(iataCode);
        case 8:
          airportCountries = _context3.sent;
          if (Array.isArray(airportCountries) && airportCountries.length) {
            newEntries = airportCountries.filter(function (a) {
              return typeof a.iataCode === 'string' && typeof a.countryIsoCode === 'string';
            }).map(function (a) {
              return [a.iataCode, a.countryIsoCode];
            });
            list = [].concat(_toConsumableArray(list), _toConsumableArray(newEntries)).sort(function (_ref6, _ref7) {
              var _ref8 = _slicedToArray(_ref6, 1),
                a = _ref8[0];
              var _ref9 = _slicedToArray(_ref7, 1),
                b = _ref9[0];
              return a.localeCompare(b);
            });
            localStorage.setItem('airportCountryCodes', JSON.stringify(list));
          } else {
            console.warn("No data returned for ".concat(iataCode));
          }
        case 10:
          return _context3.abrupt("return", new Map(list));
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function loadAirportCountries(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Adds custom parameters that need to be calculated to the event object
 * @param {object} obj - data layer object.
 * @return {object} - Returns the formatted object with the parameters as needed.
 */
var addCalculatedParameters = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(obj) {
    var airportCountries, _airportCountries$get, _airportCountries$get2;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          obj.originCountryCode = obj.originCountryCode || "";
          obj.destinationCountryCode = obj.destinationCountryCode || "";
          obj.flightType = "";
          if (!(!obj.originCountryCode || !obj.destinationCountryCode)) {
            _context4.next = 9;
            break;
          }
          _context4.next = 6;
          return loadAirportCountries(obj.airlineIataCode || obj.tenantCode);
        case 6:
          airportCountries = _context4.sent;
          if (!obj.originCountryCode && obj.originAirportIataCode) {
            obj.originCountryCode = (_airportCountries$get = airportCountries.get(obj.originAirportIataCode)) !== null && _airportCountries$get !== void 0 ? _airportCountries$get : '';
          }
          if (!obj.destinationCountryCode && obj.destinationAirportIataCode) {
            obj.destinationCountryCode = (_airportCountries$get2 = airportCountries.get(obj.destinationAirportIataCode)) !== null && _airportCountries$get2 !== void 0 ? _airportCountries$get2 : '';
          }
        case 9:
          if (obj.originCountryCode && obj.destinationCountryCode) {
            obj.flightType = obj.originCountryCode === obj.destinationCountryCode ? "DOMESTIC" : "INTERNATIONAL";
          } else {
            obj.flightType = "";
          }
          return _context4.abrupt("return", obj);
        case 11:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function addCalculatedParameters(_x4) {
    return _ref10.apply(this, arguments);
  };
}();

/**
 * Formats journey type to ONE_WAY or ROUND_TRIP.
 * @param {object} obj - data layer object.
 * @return {object} - Returns formatted journey type.
 */

var formatJourney = function formatJourney(obj) {
  if (obj.hasOwnProperty("journeyType")) {
    if (obj.journeyType.match(/(oneway|one-way|one_way|ow|one way)/gi)) {
      obj.journeyType = "ONE_WAY";
    } else if (obj.journeyType.match(/(roundtrip|round-trip|round_trip|rt|round trip)/gi)) {
      obj.journeyType = "ROUND_TRIP";
    } else {
      return obj.journeyType = "";
    }
  }
  return obj;
};

/**
 * Formats fareClass to ECONOMY, BUSINESS, or FIRST.
 * @param {object} obj - data layer object.
 * @return {object} - Returns formatted fare class.
 */
var formatFareClass = function formatFareClass(obj) {
  if (obj.hasOwnProperty('fareClass')) {
    var fareClassPatterns = [{
      pattern: /(premium\s*economy|pr)/gi,
      "class": 'PREMIUM_ECONOMY'
    }, {
      pattern: /(economy|ec|^e$)/gi,
      "class": 'ECONOMY'
    }, {
      pattern: /(business|bc|^b$|businessclass)/gi,
      "class": 'BUSINESS'
    }, {
      pattern: /(first|fc|^f$|firstclass)/gi,
      "class": 'FIRST'
    }];
    obj.fareClass = fareClassPatterns.reduce(function (acc, curr) {
      return curr.pattern.test(obj.fareClass) ? curr["class"] : acc;
    }, '');
  }
  return obj;
};

/**
 * Formats casing for different key values.
 * Events, eventAction - underscore
 * Module, actionLabel - kebab-case
 * lodging name - Titlecased
 * Rest - Capital
 * @param {object} obj - data layer object.
 * @return {object} - Returns case-converted object.
 */

var formatCase = function formatCase(obj) {
  var keyArr = ["event", "module", "eventAction", "airlineIataCode", "originAirportIataCode", "destinationAirportIataCode", "currencyCode", "route", "countryIsoCode", "cityCode", "languageIsoCode", "siteEdition", "name", "provider", "brand", "model", "tenantCode", "actionLabel", "regionName", "countryCode", "cityName", "propertyName", "eventName", "eventLocation", "eventSession", "eventExperienceCategory", "eventExperience"];
  var titleCase = ["regionName", "cityName", "propertyName", "eventName", "eventLocation", "eventSession", "eventExperienceCategory", "eventExperience", "provider"];
  var toSnakeCase = function toSnakeCase(str) {
    return str === null || str === void 0 ? void 0 : str.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s.-]+/g, "_").toLowerCase();
  };
  var toKebabCase = function toKebabCase(str) {
    return str === null || str === void 0 ? void 0 : str.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s._]+/g, "-").toLowerCase();
  };
  var toTitleCase = function toTitleCase(str) {
    return str === null || str === void 0 ? void 0 : str.replace(/\w\S*/g, function (match) {
      var _match$charAt;
      return ((_match$charAt = match.charAt(0)) === null || _match$charAt === void 0 ? void 0 : _match$charAt.toUpperCase()) + match.slice(1).toLowerCase();
    });
  };
  keyArr.forEach(function (key) {
    var _toSnakeCase, _obj$key, _obj$key2, _obj$page, _ref14, _ref15;
    if (obj.hasOwnProperty(key)) {
      switch (key) {
        case "event":
        case "eventAction":
          var eventValue = toSnakeCase(obj[key]);
          obj[key] = eventValue === 'select-stop' ? 'select_stops' : eventValue;
          if (!obj.event) obj.event = obj.eventAction;
          if (!obj.eventAction) obj.eventAction = obj.event;
          break;
        case "module":
        case "actionLabel":
          obj[key] = typeof obj[key] === "number" ? obj[key].toString() : toKebabCase(obj[key]);
          break;
        case "typeName":
          obj[key] = (_toSnakeCase = toSnakeCase(obj[key])) === null || _toSnakeCase === void 0 ? void 0 : _toSnakeCase.toUpperCase();
          break;
        default:
          obj[key] = titleCase.includes(key) ? key === "eventExperience" && obj[key].match(/(multiple|,)/gi) ? "MULTIPLE" : (_obj$key = obj[key]) !== null && _obj$key !== void 0 && _obj$key.toLowerCase().includes("n/a") ? "" : toTitleCase(obj[key]) : (_obj$key2 = obj[key]) === null || _obj$key2 === void 0 ? void 0 : _obj$key2.toUpperCase();
      }
    }
    if (obj.page !== undefined && (_obj$page = obj.page) !== null && _obj$page !== void 0 && _obj$page.hasOwnProperty(key) && (key === "languageIsoCode" || key === "siteEdition" || key === "countryIsoCode")) {
      var _ref11, _obj$page2, _ref12, _obj$page3, _siteEdition$;
      var siteEdition = toKebabCase(obj.page.siteEdition).split("-");
      obj.page.countryIsoCode = (_ref11 = ((_obj$page2 = obj.page) === null || _obj$page2 === void 0 ? void 0 : _obj$page2.countryIsoCode) || "") === null || _ref11 === void 0 ? void 0 : _ref11.toUpperCase();
      obj.page.languageIsoCode = (_ref12 = ((_obj$page3 = obj.page) === null || _obj$page3 === void 0 ? void 0 : _obj$page3.languageIsoCode) || "") === null || _ref12 === void 0 ? void 0 : _ref12.toLowerCase();
      obj.page.siteEdition = siteEdition[1] !== undefined ? "".concat(siteEdition[0], "-").concat((_siteEdition$ = siteEdition[1]) === null || _siteEdition$ === void 0 ? void 0 : _siteEdition$.toUpperCase()) : obj.page.siteEdition === "" && obj.page.languageIsoCode && obj.page.countryIsoCode !== "" ? "".concat(obj.page.languageIsoCode, "-").concat(obj.page.countryIsoCode) : siteEdition[0] || "";
    }
    if (obj.lodging !== undefined && obj.lodging.hasOwnProperty(key)) {
      if (key === "cityCode") {
        var _ref13, _obj$lodging;
        obj.lodging.cityCode = (_ref13 = ((_obj$lodging = obj.lodging) === null || _obj$lodging === void 0 ? void 0 : _obj$lodging.cityCode) || "") === null || _ref13 === void 0 ? void 0 : _ref13.toUpperCase();
      }
      if (key === "name") {
        var _charAt, _obj$lodging2, _obj$lodging3;
        obj.lodging.name = ((_charAt = (((_obj$lodging2 = obj.lodging) === null || _obj$lodging2 === void 0 ? void 0 : _obj$lodging2.name) || "").charAt(0)) === null || _charAt === void 0 ? void 0 : _charAt.toUpperCase()) + (((_obj$lodging3 = obj.lodging) === null || _obj$lodging3 === void 0 ? void 0 : _obj$lodging3.name) || "").substr(1).toLowerCase();
      }
    }
    if (obj.carRentals !== undefined && obj.carRentals.hasOwnProperty(key)) {
      switch (key) {
        case "provider":
          obj.carRentals.provider = toTitleCase(obj.carRentals.provider || "");
          break;
        case "brand":
          obj.carRentals.brand = (_ref14 = obj.carRentals.brand || "") === null || _ref14 === void 0 ? void 0 : _ref14.toUpperCase();
          break;
        case "model":
          obj.carRentals.model = (_ref15 = obj.carRentals.model || "") === null || _ref15 === void 0 ? void 0 : _ref15.toLowerCase();
          break;
      }
    }
  });
};
/**
 * Formats date to ISO format.
 * @param {object} obj - data layer object.
 * @return {object} - Returns formatted dates.
 */

var formatDate = function formatDate(obj) {
  var isAirline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var dateFields = ["departureDate", "returnDate", "timestamp", "startDate", "endDate"];
  var isValidDate = function isValidDate(date) {
    return date instanceof Date && !isNaN(date);
  };
  var formatISODate = function formatISODate(date) {
    var newDate = new Date(date);
    return isValidDate(newDate) ? newDate.toISOString().substr(0, 10) : '';
  };
  var formatISODateTime = function formatISODateTime(date) {
    var newDate = new Date(date);
    return isValidDate(newDate) ? newDate.toISOString() : '';
  };
  var parsedDates = {};
  dateFields.forEach(function (field) {
    if (obj.hasOwnProperty(field)) {
      var dateObj = new Date(obj[field]);
      parsedDates[field] = isValidDate(dateObj) ? dateObj : null;
    }
  });
  if (isAirline && parsedDates.departureDate && parsedDates.timestamp) {
    obj.daysUntilFlight = Math.round((parsedDates.departureDate - parsedDates.timestamp) / (1000 * 60 * 60 * 24));
  }
  if (parsedDates.departureDate && parsedDates.returnDate) {
    obj.tripLength = Math.round((parsedDates.returnDate - parsedDates.departureDate) / (1000 * 60 * 60 * 24));
  }
  dateFields.forEach(function (field) {
    if (parsedDates[field]) {
      obj[field] = field === 'timestamp' ? formatISODateTime(parsedDates[field]) : formatISODate(parsedDates[field]);
    } else if (obj.hasOwnProperty(field)) {
      obj[field] = '';
    }
  });
  if (obj.lodging && _typeof(obj.lodging) === 'object') {
    var lodgingObj = obj.lodging;
    if (lodgingObj.hasOwnProperty("startDate")) {
      lodgingObj.startDate = formatISODate(lodgingObj.startDate);
    }
    if (lodgingObj.hasOwnProperty("endDate")) {
      lodgingObj.endDate = formatISODate(lodgingObj.endDate);
    }
  }
  return obj;
};

/**
 * Checks whether the document/page is in an iFrame
 * @return {boolean} - Returns truthy or falsy value
 */
var checkIframe = function checkIframe() {
  try {
    if (window.self !== window.top || window.location !== window.parent.location) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return true;
  }
};

/**
 * Formats url spacing.
 * @param {object} obj - data layer object.
 * @return {object} - Returns url spaced between : and /.
 */
var formatUrl = function formatUrl(obj) {
  var _window2, _window2$EM, _window2$EM$dataLayer, _window2$EM$dataLayer2, _window2$EM$dataLayer3, _window3, _window3$EM, _window3$EM$context, _window3$EM$context$d;
  // Use URL from dataLayer or context if available
  var urlFromDataLayer = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$EM = _window2.EM) === null || _window2$EM === void 0 ? void 0 : (_window2$EM$dataLayer = _window2$EM.dataLayer) === null || _window2$EM$dataLayer === void 0 ? void 0 : (_window2$EM$dataLayer2 = _window2$EM$dataLayer[0]) === null || _window2$EM$dataLayer2 === void 0 ? void 0 : (_window2$EM$dataLayer3 = _window2$EM$dataLayer2.page) === null || _window2$EM$dataLayer3 === void 0 ? void 0 : _window2$EM$dataLayer3.url;
  var urlFromContext = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$EM = _window3.EM) === null || _window3$EM === void 0 ? void 0 : (_window3$EM$context = _window3$EM.context) === null || _window3$EM$context === void 0 ? void 0 : (_window3$EM$context$d = _window3$EM$context.datasource) === null || _window3$EM$context$d === void 0 ? void 0 : _window3$EM$context$d.url;
  if (!obj.hasOwnProperty("url") || obj["url"] === '') {
    obj.url = urlFromDataLayer || urlFromContext || '';
  }

  // Check if the URL needs to be retrieved from an iframe
  if (obj.hasOwnProperty("url")) {
    if (checkIframe()) {
      obj.url = window.parentURL !== '' ? window.parentURL : document.referrer || window.parent.location.href;
    } else if (obj["url"] === '') {
      obj.url = document.location.href;
    }
  }
  return obj;
};

/**
 * Recursive Function.
 * Replaces null values to empty string.
 * Converts numeric string values to their number value.
 * Converts true/false string values to their boolean values
 * @param {object} obj - data layer object.
 * @return {object} - Returns formatted object.
 */
var convertValues = function convertValues(obj) {
  var formatNumber = function formatNumber(num) {
    var parsedNum = parseFloat(num);
    return isNaN(parsedNum) ? num : parseFloat(parsedNum.toFixed(2));
  };
  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      var value = obj[property];
      if (value === null || value === undefined) {
        obj[property] = "";
      } else if (_typeof(value) === "object") {
        convertValues(value);
      } else if (typeof value === "string") {
        if (!isNaN(value) && !isNaN(parseFloat(value))) {
          obj[property] = +value;
        } else if (value.toLowerCase() === "false" || value.toLowerCase() === "true") {
          obj[property] = value.toLowerCase() === "true";
        }
      } else if (typeof value === "number") {
        obj[property] = formatNumber(value);
      }
    }
  }
  if (obj.hasOwnProperty('totalPrice')) {
    obj.totalPrice = formatNumber(obj.totalPrice);
  }
  if (obj.hasOwnProperty('totalPriceUSD')) {
    obj.totalPriceUSD = formatNumber(obj.totalPriceUSD);
  }
  return obj;
};
var formatDetails = function formatDetails(obj) {
  var tenantType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  try {
    var _window4, _window4$EM, _window5, _window5$EM, _window5$EM$dataLayer, _context$airline, _dataLayer$airline, _context$airline2, _dataLayer$airline2, _obj$budget, _obj$startDate, _context$geo, _context$geo$language, _context$geo$language2, _dataLayer$page, _dataLayer$page$siteE, _context$geo2, _context$geo2$languag, _dataLayer$page2, _context$geo3, _context$geo3$languag, _dataLayer$page3;
    var context = (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$EM = _window4.EM) === null || _window4$EM === void 0 ? void 0 : _window4$EM.context;
    var dataLayer = (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$EM = _window5.EM) === null || _window5$EM === void 0 ? void 0 : (_window5$EM$dataLayer = _window5$EM.dataLayer) === null || _window5$EM$dataLayer === void 0 ? void 0 : _window5$EM$dataLayer[0];
    var providerName = (context === null || context === void 0 ? void 0 : (_context$airline = context.airline) === null || _context$airline === void 0 ? void 0 : _context$airline.name) || (dataLayer === null || dataLayer === void 0 ? void 0 : (_dataLayer$airline = dataLayer.airline) === null || _dataLayer$airline === void 0 ? void 0 : _dataLayer$airline.name) || '';
    var code = (context === null || context === void 0 ? void 0 : (_context$airline2 = context.airline) === null || _context$airline2 === void 0 ? void 0 : _context$airline2.code) || (dataLayer === null || dataLayer === void 0 ? void 0 : (_dataLayer$airline2 = dataLayer.airline) === null || _dataLayer$airline2 === void 0 ? void 0 : _dataLayer$airline2.iataCode) || '';
    var dynamicContext = (context === null || context === void 0 ? void 0 : context.dynamicContext) || {};
    var journeyType = dynamicContext.productCategory,
      fareClass = dynamicContext.productType,
      isFlexibleDates = dynamicContext.isFlexibleDates,
      discountCode = dynamicContext.discountCode,
      isRedemption = dynamicContext.isRedemption;

    // Format tp_v
    obj.tp_v = version;

    // Handle special case for actionLabel -> "budget"
    obj.actionLabel = (_obj$budget = obj === null || obj === void 0 ? void 0 : obj.budget) !== null && _obj$budget !== void 0 ? _obj$budget : obj.actionLabel;

    // Format airline name
    var finalAirlineName = obj.provider ? obj.provider : providerName;
    finalAirlineName = finalAirlineName.match(/[a-zA-Z0-9]+/g) ? finalAirlineName.split(" ").map(function (key) {
      var _key$charAt, _key$slice;
      return ((_key$charAt = key.charAt(0)) === null || _key$charAt === void 0 ? void 0 : _key$charAt.toUpperCase()) + ((_key$slice = key.slice(1)) === null || _key$slice === void 0 ? void 0 : _key$slice.toLowerCase());
    }).join("") : '';
    obj.provider = finalAirlineName || obj.provider;

    // Handle tenant code based on the type
    if (tenantType !== 'airline' && !obj.tenantCode || obj.tenantCode === '') {
      obj.tenantCode = code === null || code === void 0 ? void 0 : code.toUpperCase();
    }
    if (tenantType === 'airline' && !obj.airlineIataCode || obj.airlineIataCode === '') {
      obj.airlineIataCode = code === null || code === void 0 ? void 0 : code.toUpperCase();
    }

    // Calculate days until booking for hotels
    if (tenantType === 'hotel' && !obj.daysUntilBooking && (_obj$startDate = obj.startDate) !== null && _obj$startDate !== void 0 && _obj$startDate.trim()) {
      var startDate = new Date(obj.startDate);
      var today = new Date();
      var timeDiff = startDate - today;
      var daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      obj.daysUntilBooking = daysDiff;
    }

    // Handle additional properties
    obj.journeyType = obj.journeyType || journeyType || '';
    obj.fareClass = obj.fareClass || fareClass || '';
    obj.isFlexibleDates = obj.isFlexibleDates !== undefined ? obj.isFlexibleDates : isFlexibleDates || false;
    obj.discountCode = obj.discountCode || discountCode || '';

    // Check for miles
    if (tenantType === 'airline' && isRedemption !== undefined && obj.miles === undefined) {
      obj.miles = isRedemption;
    }
    var ptnMappings = {
      "city-to-city": "CITY_TO_CITY",
      "to-city": "TO_CITY",
      "from-city": "FROM_CITY",
      "city-to-country": "CITY_TO_COUNTRY",
      "country-to-city": "COUNTRY_TO_CITY",
      "country-to-country": "COUNTRY_TO_COUNTRY",
      "from-country": "FROM_COUNTRY",
      "to-country": "TO_COUNTRY",
      "from-state": "FROM_STATE",
      "from-airport": "FROM_AIRPORT",
      "bus-station": "BUS_STATION",
      "city_to_city": "CITY_TO_CITY",
      "to_city": "TO_CITY",
      "from_city": "FROM_CITY",
      "city_to_country": "CITY_TO_COUNTRY",
      "country_to_city": "COUNTRY_TO_CITY",
      "country_to_country": "COUNTRY_TO_COUNTRY",
      "from_country": "FROM_COUNTRY",
      "to_country": "TO_COUNTRY",
      "from_state": "FROM_STATE",
      "from_airport": "FROM_AIRPORT",
      "bus_station": "BUS_STATION",
      "home": "HOMEPAGE",
      "hp": "EXTERNALIZED",
      "homepage": "EXTERNALIZED",
      "home page": "EXTERNALIZED",
      "discovery": "EXTERNALIZED",
      "confirmationpage": "EXTERNALIZED",
      "coresite-custom-best-fare-finder": "EXTERNALIZED"
    };
    var validTypeNames = new Set(Object.values(ptnMappings));
    var CUSTOM_PAGE_RX = /\bcustom page\b/i;
    var normalize = function normalize(s) {
      return s.trim().toLowerCase().replace(/[\s-]+/g, "_");
    };
    var getMappedTypeName = function getMappedTypeName(key) {
      if (!key) return null;
      var mapped = ptnMappings[normalize(key)];
      return validTypeNames.has(mapped) ? mapped : null;
    };
    var resolveTypeName = function resolveTypeName() {
      var _EM, _EM$context, _EM$context$datasourc, _getMappedTypeName, _EM2, _EM2$context, _EM2$context$datasour;
      return CUSTOM_PAGE_RX.test((_EM = EM) === null || _EM === void 0 ? void 0 : (_EM$context = _EM.context) === null || _EM$context === void 0 ? void 0 : (_EM$context$datasourc = _EM$context.datasource) === null || _EM$context$datasourc === void 0 ? void 0 : _EM$context$datasourc.step) ? "CUSTOM_PAGE" : (_getMappedTypeName = getMappedTypeName((_EM2 = EM) === null || _EM2 === void 0 ? void 0 : (_EM2$context = _EM2.context) === null || _EM2$context === void 0 ? void 0 : (_EM2$context$datasour = _EM2$context.datasource) === null || _EM2$context$datasour === void 0 ? void 0 : _EM2$context$datasour.step)) !== null && _getMappedTypeName !== void 0 ? _getMappedTypeName : "n/a";
    };
    obj.page.typeName = resolveTypeName();

    // Handle site edition, country, and language codes
    obj.page.siteEdition = obj.page.siteEdition || (context === null || context === void 0 ? void 0 : (_context$geo = context.geo) === null || _context$geo === void 0 ? void 0 : (_context$geo$language = _context$geo.language) === null || _context$geo$language === void 0 ? void 0 : (_context$geo$language2 = _context$geo$language.site_edition) === null || _context$geo$language2 === void 0 ? void 0 : _context$geo$language2.toUpperCase()) || (dataLayer === null || dataLayer === void 0 ? void 0 : (_dataLayer$page = dataLayer.page) === null || _dataLayer$page === void 0 ? void 0 : (_dataLayer$page$siteE = _dataLayer$page.siteEdition) === null || _dataLayer$page$siteE === void 0 ? void 0 : _dataLayer$page$siteE.toUpperCase()) || '';
    obj.page.countryIsoCode = obj.page.countryIsoCode || (context === null || context === void 0 ? void 0 : (_context$geo2 = context.geo) === null || _context$geo2 === void 0 ? void 0 : (_context$geo2$languag = _context$geo2.language) === null || _context$geo2$languag === void 0 ? void 0 : _context$geo2$languag.siteEditionMarket) || (dataLayer === null || dataLayer === void 0 ? void 0 : (_dataLayer$page2 = dataLayer.page) === null || _dataLayer$page2 === void 0 ? void 0 : _dataLayer$page2.countryIsoCode) || '';
    obj.page.languageIsoCode = obj.page.languageIsoCode || (context === null || context === void 0 ? void 0 : (_context$geo3 = context.geo) === null || _context$geo3 === void 0 ? void 0 : (_context$geo3$languag = _context$geo3.language) === null || _context$geo3$languag === void 0 ? void 0 : _context$geo3$languag.siteEditionLanguage) || (dataLayer === null || dataLayer === void 0 ? void 0 : (_dataLayer$page3 = dataLayer.page) === null || _dataLayer$page3 === void 0 ? void 0 : _dataLayer$page3.languageIsoCode) || '';

    // Handle guest and passenger counts
    var normalizeCount = function normalizeCount(obj, key) {
      if (obj[key]) {
        var normalizedKeys = Object.keys(obj[key]).reduce(function (acc, k) {
          acc[k.toLowerCase()] = obj[key][k];
          return acc;
        }, {});
        obj[key].adultCount = normalizedKeys.adultcount || normalizedKeys.adult || 0;
        obj[key].childCount = normalizedKeys.childcount || normalizedKeys.child || 0;
      }
    };
    normalizeCount(obj, 'guest');
    normalizeCount(obj, 'passenger');
    return obj;
  } catch (error) {
    console.error('Error in formatDetails:', error.message);
    return obj; // Return the original object in case of error
  }
};
var filterObjectBySchema = function filterObjectBySchema(obj, schema) {
  var filteredObj = {};
  for (var key in schema) {
    if (obj.hasOwnProperty(key)) {
      if (_typeof(schema[key]) === 'object' && !Array.isArray(schema[key])) {
        filteredObj[key] = filterObjectBySchema(obj[key], schema[key]);
      } else {
        filteredObj[key] = obj[key];
      }
    }
  }
  if (obj.hasOwnProperty('configuration')) {
    filteredObj['configuration'] = obj['configuration'];
  }
  return filteredObj;
};
var pushFormattedEventData = function pushFormattedEventData(obj, schema) {
  if (!window) {
    error('window is not defined');
  } else {
    var _tealiumList$tenantCo;
    var tenantCode = obj.airlineIataCode || obj.tenantCode;
    var whiteList = (_tealiumList$tenantCo = tealiumList === null || tealiumList === void 0 ? void 0 : tealiumList[tenantCode]) !== null && _tealiumList$tenantCo !== void 0 ? _tealiumList$tenantCo : false;
    var filteredObj = filterObjectBySchema(obj, schema);
    logger.log("Formatted event obj:", filteredObj);
    if (window.utag && whiteList) {
      window.utag.link(filteredObj);
    } else {
      logger.log("utag.link not enabled");
    }
    if (window.dataLayer) {
      if (window.localDataLayer && window.localDataLayer.length > 0) {
        var _window$dataLayer;
        (_window$dataLayer = window.dataLayer).push.apply(_window$dataLayer, _toConsumableArray(window.localDataLayer));
        window.localDataLayer = [];
      }
      window.dataLayer.push(filteredObj);
    } else {
      window.localDataLayer = [];
      window.localDataLayer.push(filteredObj);
    }
  }
};
var formatter = {
  formatAirlines: formatAirlines,
  formatHotels: formatHotels,
  formatEvents: formatEvents
};
export { formatter, fetchAirportCountries };
export default formatter;